import React, { useEffect, useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import {
	BackendWrapper,
	NavigationWrapper,
	SessionWrapper,
	UiWrapper,
} from '@coinscrap/webapp-core';
import { MainModal } from 'components/MainModal/MainModal';
import { useGetError } from 'hooks/useGetError';

export const useLoginClient = () => {
	const { navigateTo, query } = NavigationWrapper.use();
	const { getInstanceApi } = BackendWrapper.use();
	const { startSession, clearSession } = SessionWrapper.use();
	const { openModal } = UiWrapper.use();

	const [loading, setLoading] = useState();
	const getError = useGetError();

	useEffect(() => {
		clearSession();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		(async () => {
			await new Promise((r) => setTimeout(r, 750));
			let response;
			try {
				setLoading('Accediendo...');
				response = await getInstanceApi().loginUser(
					{
						source: query?.source || '000',
					},
					'anonymous',
				);

				await startSession({ token: response.accessToken });
				await new Promise((r) => setTimeout(r, 750));

				localStorage.removeItem('B2Flow');
				localStorage.setItem('B2Flow', 'B2C');

				console.info('🚀 LOGGED IN', 'B2Flow', 'B2C');

				setLoading(undefined);
				CONFIG.routing.loginClient.next(navigateTo);
			} catch (e) {
				setLoading(undefined);
				openModal(() => <MainModal type="error" text={getError(e)} />, {
					disableClickAway: true,
					closeButton: false,
					modalClass: isMobile ? 'modal-xl' : 'modal-main',
					key: 'modal-useLoginClient-KO',
				});
			}
		})();
		// eslint-disable-next-line
	}, []);

	return { loading };
};
